import BaseApi from "./BaseApi";

export default class StaffApi extends BaseApi {
  static getTeamStaff = (fedTeamId, tournamentType) => this.get(`team/${fedTeamId}/${tournamentType}/personnel`);
  static removeStaff = profileId => this.delete(`personnel/${profileId}`);
}
